import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

// Single registration point for the public site's GSAP plugins.
gsap.registerPlugin(ScrollTrigger, SplitText);

// House easing: "ink, not glow". Everything settles, nothing bounces.
export const EASE = "expo.out";

export const prefersReducedMotion = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export { gsap, ScrollTrigger, SplitText };
